import { render, staticRenderFns } from "./WcLoadersList.vue?vue&type=template&id=24c714da&lang=pug&"
import script from "./WcLoadersList.vue?vue&type=script&lang=js&"
export * from "./WcLoadersList.vue?vue&type=script&lang=js&"
import style0 from "./WcLoadersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports